var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.56526 3.64852L5.35079 2.64921L4.35148 3.43474L4 0.5L3.64852 3.43474L2.64921 2.64921L3.43474 3.64852L0.5 4L3.43474 4.35148L2.64921 5.35079L3.64852 4.56526L4 7.5L4.35148 4.56526L5.35079 5.35079L4.56526 4.35148L7.5 4L4.56526 3.64852Z",
    fill: "#827677"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallStar);
export default __webpack_public_path__ + "static/media/small-star.19d6311f0aad57d9bd9afcc53e8ac3b6.svg";
export { ForwardRef as ReactComponent };